import { ValidationFormField } from '@eventbrite/eds-validation-form-field';
import { GenericLazyString } from '@eventbrite/i18n';
import {
    getFormValidationAdornment,
    TextField,
    VFFTextFieldAdapter,
} from '@eventbrite/marmalade';
import { shouldDisplayError } from '@eventbrite/redux-form-tools';
import classNames from 'classnames';
import React from 'react';
import { PROMO_CODE_FIELD_NAME } from './constants';

const DEBOUNCE_TIME = 500;

export interface PromoCodeInputFieldProps {
    cta: React.ReactNode;
    handleSubmit: () => void;
    helperText?: string;
    inputLabel: string | GenericLazyString;
    inputPlaceholder: string | GenericLazyString;
    isCodeSuccessful: boolean;
    onChange: () => void;
    submitFailed: boolean;
}

export const PromoCodeInputField: React.FunctionComponent<
    PromoCodeInputFieldProps
> = ({
    cta,
    handleSubmit,
    helperText,
    inputLabel,
    inputPlaceholder,
    isCodeSuccessful,
    onChange,
    submitFailed,
}) => {
    const formClassName = classNames('responsive-form', 'eds-g-group');

    const adornment = getFormValidationAdornment({
        hasError: submitFailed,
        isValid: isCodeSuccessful,
    });

    let timer: NodeJS.Timeout | null = null;
    const debouncedSubmit = (e: any) => {
        e.preventDefault();
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        timer = setTimeout(handleSubmit, DEBOUNCE_TIME);
    };

    return (
        <form
            className={formClassName}
            onSubmit={debouncedSubmit}
            data-automation="promo-code-form"
            data-testid="promo-code-form"
        >
            <div className="eds-g-cell eds-g-cell-12-12">
                <ValidationFormField
                    name={PROMO_CODE_FIELD_NAME}
                    shouldDisplayError={shouldDisplayError}
                    v2={true}
                >
                    <VFFTextFieldAdapter onChange={onChange}>
                        <TextField
                            data-automation="promo-code-field"
                            data-spec="promo-code-field"
                            disabled={isCodeSuccessful}
                            id="promo-code-field"
                            label={inputLabel}
                            placeholder={inputPlaceholder}
                            suffix={cta}
                            type="text"
                            validationAdornment={adornment}
                            helperText={helperText}
                        />
                    </VFFTextFieldAdapter>
                </ValidationFormField>
            </div>
        </form>
    );
};
